import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly http = inject(HttpClient);

  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>('/api/users');
  }

  getUserById(id: string): Observable<User> {
    return this.http.get<User>(`/api/users/${id}`);
  }

  getUserbyAuth0Id(id: string): Observable<User> {
    return this.http.get<User>(`/api/users/auth0/${id}`);
  }

  deleteUserById(id: string): Observable<User> {
    return this.http.delete<User>(`/api/users/${id}`);
  }
}
